function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import PropTypes from "prop-types";
import React from "react";

function SearchBox(props) {
  var isFocused = props.isFocused,
      inputProps = props.inputProps,
      onChange = props.onChange,
      onSubmit = props.onSubmit,
      value = props.value;
  var focusedClass = isFocused ? "focus" : "";
  return React.createElement("form", {
    className: "sui-search-box",
    onSubmit: onSubmit
  }, React.createElement("input", _extends({
    className: "sui-search-box__text-input ".concat(focusedClass),
    onChange: onChange,
    type: "text",
    value: value,
    placeholder: "Search your documents\u2026"
  }, inputProps)), React.createElement("input", {
    type: "submit",
    value: "Search",
    className: "button sui-search-box__submit"
  }));
}

SearchBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  inputProps: PropTypes.object,
  isFocused: PropTypes.bool
};
export default SearchBox;